import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { BrowserRouter, Routes, Route } from "react-router";
import Cookies from "js-cookie";
import { useGoogleLogin } from "@react-oauth/google";

import "./App.css";

import UserLayout from "./components/UserLayout.jsx";

import Scans from "./pages/Scans.jsx";
import NewScan from "./pages/NewScan.jsx";
import Scan from "./pages/Scan.jsx";
import Account from "./pages/Account.jsx";

import About from "./pages/About.jsx";
import NoPage from "./pages/NoPage.jsx";

export default function Main() {
  // eslint-disable-next-line
  const [self, set_self] = useState();
  const [loading, set_loading] = useState(true);

  const logout = useCallback(() => {
    set_self();
    Cookies.remove("google-access-token");
    delete axios.defaults.headers.common["google-access-token"];
    window.location.href = "/";
  }, []);

  const login = useCallback(
    (google_access_token) => {
      axios({
        method: "get",
        url: `${process.env.REACT_APP_BE_URL}/auth/login`,
        headers: { "google-access-token": google_access_token },
      })
        .then((res) => {
          set_self(res.data);
          Cookies.set("google-access-token", google_access_token);
          axios.defaults.headers.common["google-access-token"] = Cookies.get(
            "google-access-token"
          );
        })
        .catch((err) => {
          logout();
          console.log(err);
          console.log(JSON.stringify(err));
        })
        .finally(() => set_loading(false));
    },
    [logout]
  );

  const first_login = useGoogleLogin({
    onSuccess: (res) => {
      login(res.access_token);
    },
    scope: [
      "openid",
      "https://www.googleapis.com/auth/userinfo.profile",
      "https://www.googleapis.com/auth/userinfo.email",
    ].join(" "),
    onError: (err) => {
      logout();
      console.error(err);
    },
  });

  useEffect(() => {
    document.title = "Cybersecurity";
    const google_access_token = Cookies.get("google-access-token");
    if (google_access_token) login(google_access_token);
    else
      axios({ method: "get", url: `${process.env.REACT_APP_BE_URL}` })
        .then((res) => {
          console.log(res.data);
          set_loading(false);
        })
        .catch((err) => console.log(err));
  }, [login]);

  return (
    <BrowserRouter>
      <Routes>
        {loading && (
          <Route
            path="*"
            element={<>loading... {`${process.env.REACT_APP_BE_URL}`}</>}
          />
        )}

        {!loading && !self && (
          <>
            <Route index element={<About first_login={first_login} />} />
            <Route path="a" element={<>aaa</>} />
          </>
        )}

        {!loading && self && (
          <>
            <Route
              element={
                <UserLayout self={self} set_self={set_self} logout={logout} />
              }
            >
              <Route index element={<NewScan />} />
              <Route path="scans" element={<Scans />} />
              <Route path="scan" element={<NewScan />} />
              <Route path="scan/:apexdomain" element={<Scan />} />

              <Route path="account" element={<Account />} />
            </Route>
          </>
        )}

        <Route path="*" element={<NoPage />} />
      </Routes>
    </BrowserRouter>
  );
}
